import { render, staticRenderFns } from "./FilterBasicComponent.vue?vue&type=template&id=282e2347&scoped=true&lang=pug"
import script from "./FilterBasicComponent.vue?vue&type=script&lang=js"
export * from "./FilterBasicComponent.vue?vue&type=script&lang=js"
import style0 from "./FilterBasicComponent.vue?vue&type=style&index=0&id=282e2347&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282e2347",
  null
  
)

export default component.exports